import thunkMiddleware from 'redux-thunk';
import { Globals } from '@bwoty-web/ui-kit';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { compose, createStore, applyMiddleware } from 'redux';

import priceMatrixApp from './redux/reducers/priceMatrix';
import PriceMatrixContainer from './containers/PriceMatrixContainer';

const initialState = window.__INITIAL_STATE_IW_PRICE_MATRIX__;
delete window.__INITIAL_STATE_IW_PRICE_MATRIX__;

const commonState = () => initialState;

const finalCreateStore = compose(applyMiddleware(thunkMiddleware))(createStore);

if (initialState) {
  const priceMatrixStore = finalCreateStore(priceMatrixApp(commonState));
  const { siteSettings } = initialState;

  const root = createRoot(document.getElementById('iw-price-matrix'));
  root.render(
    <Globals
      siteId={siteSettings?.siteId || 1}
      legacyMode={siteSettings?.legacyMode}
    >
      <Provider store={priceMatrixStore}>
        <PriceMatrixContainer />
      </Provider>
    </Globals>,
  );
}
